module.exports = __webpack_public_path__ + "static/img/dxd@2x.4c398738.png";